// components/dialog-system-manager.tsx
"use client";

import { useEffect } from "react";
// 🚀 Import the flag alongside the store
import {
  useDialogSystemStore,
  dialogNavigationState,
} from "@/hooks/use-dialog-routing";

export default function DialogSystemManager() {
  const popTop = useDialogSystemStore((s) => s.popTop);

  useEffect(() => {
    const handlePopState = () => {
      // 🚀 3. If the hook called history.back() to clean up, ignore this event!
      if (dialogNavigationState.isProgrammaticBack) {
        dialogNavigationState.isProgrammaticBack = false; // Reset the flag
        return;
      }

      // Otherwise, it was the real physical Back button on mobile
      popTop();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        const stackLength = useDialogSystemStore.getState().stack.length;
        if (stackLength > 0) {
          e.preventDefault();
          // Escape triggers a manual browser back, which fires popstate.
          // Because we DIDN'T set the flag to true here, popTop() will run!
          window.history.back();
        }
      }
    };

    window.addEventListener("popstate", handlePopState);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [popTop]);

  return null;
}
